import React__default from 'react';
import clsx from 'clsx';
import StyledKPortal from './index.styled.js';

var KPortal = function (_a) {
    var className = _a.className, style = _a.style, cardCount = _a.cardCount, firstLarger = _a.firstLarger, gridColumnSize = _a.gridColumnSize, gridLargeColumnSize = _a.gridLargeColumnSize, children = _a.children, sx = _a.sx;
    return (React__default.createElement(StyledKPortal, { className: clsx("KPortal", className), style: style, cardCount: cardCount, firstLarger: firstLarger, gridColumnSize: gridColumnSize, gridLargeColumnSize: gridLargeColumnSize, sx: sx }, children));
};

export { KPortal as default };
//# sourceMappingURL=index.js.map
